export let isRefreshing = false

export function setRefreshing(value: boolean) {
	isRefreshing = value
}
